/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserPopoverOverviewContainer_viewer = {
    readonly id: string;
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly " $refType": "UserPopoverOverviewContainer_viewer";
};
export type UserPopoverOverviewContainer_viewer$data = UserPopoverOverviewContainer_viewer;
export type UserPopoverOverviewContainer_viewer$key = {
    readonly " $data"?: UserPopoverOverviewContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverOverviewContainer_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "UserPopoverOverviewContainer_viewer",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "ignoredUsers",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'cab0b464ed6eead8b655991d3b3b9cf3';
export default node;
